import { useGetEdgeConfig } from "@/api/edgeConfig"
import { MyAccountRoute } from "@/constants/routes/myAccount"
import { PublicRoute } from "@/constants/routes/public"
import nativeHelper from "@/lib/nativeHelper"
import { computed, ref, watchEffect } from "vue"
import { useRouter } from "vue-router"

export function useMaintenance() {
  const router = useRouter()
  const query = useGetEdgeConfig(nativeHelper.isNative())
  const isMaintenanceSheetOpen = ref(false)

  const isNativeMaintenanceBannerEnabled = computed(
    () => query.data.value?.isMaintenanceBannerEnabled ?? false,
  )

  const maintenanceBannerContent = computed(
    () => query.data.value?.maintenanceBannerContent,
  )

  const isMaintenanceMode = computed(
    () => query.data.value?.isMaintenancePageEnabled ?? false,
  )

  const isOnMaintenancePage = computed(
    () => router.currentRoute.value.path === PublicRoute.maintenance,
  )

  const shouldShowMaintenanceSheet = computed(
    () => !isMaintenanceMode.value && isNativeMaintenanceBannerEnabled.value,
  )

  function handleMaintenanceRouting() {
    if (isMaintenanceMode.value && !isOnMaintenancePage.value) {
      router.replace(PublicRoute.maintenance)
      return
    }

    if (!isMaintenanceMode.value && isOnMaintenancePage.value) {
      router.replace(MyAccountRoute.home)
    }
  }

  function handleMaintenanceSheet() {
    if (!shouldShowMaintenanceSheet.value) {
      isMaintenanceSheetOpen.value = false
      return
    }

    isMaintenanceSheetOpen.value = true
  }

  watchEffect(() => {
    handleMaintenanceRouting()
    handleMaintenanceSheet()
  })

  return {
    ...query,
    isNativeMaintenanceBannerEnabled,
    isMaintenanceSheetOpen,
    maintenanceBannerContent,
  }
}
